import { useState, useEffect, useCallback } from 'react'
const DEBUG_KEY = 'communityshare-debug'

function getDebugValue() {
  try {
    const stored = localStorage.getItem(DEBUG_KEY)
    return stored !== null ? JSON.parse(stored) : false
  } catch {
    return false
  }
}

export function useDebug() {
  const [debug, setDebug] = useState(getDebugValue)

  useEffect(() => {
    const handleStorage = (e) => {
      if (e.key === DEBUG_KEY) {
        setDebug(e.newValue !== null ? JSON.parse(e.newValue) : false)
      }
    }
    window.addEventListener('storage', handleStorage)
    return () => window.removeEventListener('storage', handleStorage)
  }, [])

  const setDebugValue = useCallback((value) => {
    localStorage.setItem(DEBUG_KEY, JSON.stringify(value))
    setDebug(value)
  }, [])

  return [debug, setDebugValue]
}
